// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wf_a bho_b","TwoDimsListFeature__item":"wf_b bho_we","TwoDimsListFeature__item__text":"wf_c bho_vt"};